<template>
  <div class="pages">
    <!-- 导航 -->
    <shortcut></shortcut>
    <!-- 导航 -->

    <!-- 头部 -->

    <commonHeader></commonHeader>
    <!-- 头部 -->
    <div class="content">
      <div class="subtitle">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t('首页')}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{t(type)}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="datalist">
        <div class="list">
          <div class="item"
               v-for="(item,index) in dataList"
               :key="index"
               @click="getDetail(item.id)">
            <div class="left">
              <span class="tag">{{t(type)}}</span>
              <span>| {{item.title}}</span>
            </div>
            <span class="right">{{$jx.timeFormat(item.createtime,'yyyy-mm-dd') }}</span>
          </div>
        </div>
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="10"
                       layout="prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
    <foot style="padding-top: 15px;"></foot>
  </div>
</template>

<script>
import shortcut from '@/components/shortcut/shortcut.vue';
import foot from '@/components/footer/footer.vue';
export default {

  components: {
    shortcut,
    foot
  },
  data () {
    return {
      dataList: [],
      id: 0,
      total: 0,
      type: 0,
      currentPage: 1
    }
  },
  mounted () {
    this.type = this.$route.params.id;
    this.getNewlists()
  },
  computed: {

  },
  beforeDestroy () {

  },
  methods: {
    t (index) {
      switch (index) {
        case '0':
          return '新品推荐'
          break;
        case '1':
          return '推荐供应商'
          break;
        case '2':
          return '应用与分享'
          break;
        case '3':
          return '最新资讯'
          break;

        default:
          break;
      }
    },
    getDetail (id) {
      this.$router.push({
        path: `/news/details/${id}`,
      })
    },
    handleSizeChange () { },
    handleCurrentChange () {

    },
    getNewlists () {
      let that = this
      this.$http.get("/wanlshop/news/newlists", {
        type: this.$route.params.id || this.type,
      }).then(res => {
        that.dataList = res.data.data
        that.total = res.data.total
      })
    }
  },
};

</script>
<style scoped lang="scss">
.el-pagination {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 20px;
}

.pages {
  background-color: #f4f4f4;

  .header {
    .block {
      max-width: 1200px;
      min-width: 1200px;
      height: 120px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 80px;
        }

        .cl {
          color: #fff;
          background-color: #0094e7;
          line-height: 36px;
          width: 190px;
          padding: 0 15px;
          font-size: 14px;
          box-sizing: border-box;
          margin-top: 10px;
          font-weight: 600;
        }
      }

      .center {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        flex: 1;
        overflow: hidden;

        .top {
          width: 100%;
          box-sizing: border-box;
          padding: 0 30px;

          .search {
            display: flex;
            justify-content: flex-start;
            padding-left: 50px;

            .blocks {
              display: flex;
              flex-direction: column;

              .hot {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .item {
                  color: #999999;
                  font-size: 12px;
                  margin: 0 4px;

                  &.cur {
                    color: #0094e7;
                  }
                }
              }

              .inputs {
                width: 600px;
                border: 2px solid #0094e7;
                height: 32px;
                display: flex;
                justify-content: space-between;
                margin-right: 20px;
                margin-bottom: 10px;

                select {
                  border: none;
                  outline: none;
                  color: #0094e7;
                  padding: 0 8px;
                  border-right: 1px solid #0094e7;
                }

                input {
                  flex: 1;
                  border: none;
                  outline: none;
                  position: relative;
                  padding: 0 10px;
                  font-size: 14px;
                }

                .ss {
                  width: 50px;
                  background-color: #0094e7;
                  box-sizing: border-box;
                }
              }
            }

            .cart {
              height: 32px;
              line-height: 32px;
              color: #0094e7;
              font-size: 12px;
              border: 1px solid #dddddd;
              padding: 0 30px;
            }
          }
        }

        .tab {
          width: 100%;
          margin-bottom: 4px;
          padding: 0 30px;
          box-sizing: border-box;

          .list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .item {
              white-space: nowrap;
              margin: 0 10px;
              font-size: 16px;
              color: #333333;
              position: relative;

              &:first-child {
                margin-left: 0;
              }

              &:last-child {
                margin-right: 0;
              }

              .t {
                position: absolute;
                background-color: #0094e7;
                color: #fff;
                top: -24px;
                left: 50%;
                transform: translateX(-50%);
                font-size: 12px;
                display: inline-block;
                border-radius: 4px;
                height: 20px;
                line-height: 20px;
                padding: 0 4px;

                &::after {
                  content: "";
                  width: 0;
                  height: 0;
                  border: 5px solid;
                  border-color: #0094e7 transparent transparent transparent;
                  position: absolute;
                  top: 20px;
                  left: 50%;
                  transform: translateX(-50%);
                }
              }
            }
          }
        }
      }
    }
  }

  .content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-width: 1200px;
    max-width: 1200px;
    margin: 0 auto;

    .subtitle {
      font-size: 14px;
      color: #333333;
      margin: 15px 0;
    }

    .datalist {
      background-color: #fff;
      border-radius: 6px;

      .list {
        padding: 10px 20px;

        .item {
          padding: 10px 0;
          display: flex;
          justify-content: space-between;
          cursor: pointer;

          .left {
            font-size: 14px;
            color: #333;

            .tag {
              color: #b1b1b1;
            }
          }

          .right {
            color: #b1b1b1;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/list.vue